import React, { MouseEventHandler, ReactElement } from 'react';
import { useLocation } from 'hooks/use-location';
import { useCompany } from 'hooks/use-selector';
import Link from 'atomic/link/link';

import fbIcon from 'assets/icons/facebook.inline.svg';
import linkedinIcon from 'assets/icons/linkedin.inline.svg';

import './company-view-cart-summary-share.scss';

const CompanyViewCardSummaryShare: React.FC = (): ReactElement => {
    const { location } = useLocation();
    const company = useCompany();

    const onFbClick: MouseEventHandler = e => {
        e.preventDefault();

        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&t=Opineo.pl - ${company.name}`,
            '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
        );
    };

    const onLinkedInClick: MouseEventHandler = e => {
        e.preventDefault();

        window.open(
            `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`,
            '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
        );
    };

    return (
        <div className="company-view-card__summary-share">
            Udostępnij:
            <Link
                className="company-view-card__summary-share-link"
                href={`https://www.facebook.com/sharer/sharer.php?u=${location.url}&t=Opineo.pl - ${company.name}`}
                onClick={onFbClick}
            >
                <img src={fbIcon} alt="Udostępnij na Facebooku" className="company-view-card__summary-share-img"/>
            </Link>
            <Link
                className="company-view-card__summary-share-link"
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${location.url}`}
                onClick={onLinkedInClick}
            >
                <img src={linkedinIcon} alt="Udostępnij na LinkedIn" className="company-view-card__summary-share-img"/>
            </Link>
        </div>
    );
};

export default CompanyViewCardSummaryShare;
